import styles from './bundleTitleRow.module.css'
import classNames from 'classnames'

type Props = {
  title: React.ReactNode | string,
  subtitle?: React.ReactNode | string,
  titleClassName?: string,
  secondary?: React.ReactNode | string,
}

const BundleTitleRow = ({ title, subtitle, titleClassName = '', secondary }: Props) => {
  return <div className={styles.titleRow}>
    <h1 className={classNames(styles.title, titleClassName)}>
      { title }
      { subtitle && <span className={styles.subtitle}>{ subtitle }</span> }
    </h1>
    { secondary }
  </div>
}

export default BundleTitleRow
